import { useState, useEffect } from 'react';

export const useDeviceRatio = () => {
  const [ratio, setRatio] = useState<number>(window.devicePixelRatio);
  useEffect(() => {
    const handleResize = () => setRatio(window.devicePixelRatio);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return { ratio };
};
